<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="700px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-chart-line</v-icon>
              <span class="px-3">{{ $t('Edit Closing Entry Information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs6 sm6 class="pa-2">
              <v-text-field
                v-model="viewInfo.closing_title"
                :label="$t('Title')"
                box
                name="closing_title"
                hide-details
                background-color="white"
                :error="errors.has('closing_title')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs6 sm6 class="pa-2">
              <v-menu v-model="dateMenu" full-width max-width="290" :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  :value="viewInfo.closing_date"
                  :label="`${$t('Date')} *`"
                  prepend-inner-icon="event"
                  box
                  readonly
                  hide-details
                  name="closing_date"
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('closing_date')"
                  v-validate="'required|date_format:yyyy-MM-dd'"
                />
                <v-date-picker @change="dateMenu = false" v-model="viewInfo.closing_date" />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm12 md12 class="pa-2">
              <v-textarea
                v-model="viewInfo.closing_note"
                :label="`${$t('Note')}`"
                name="closing_note"
                hide-details
                box
                height="80"
                background-color="white"
              />
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnUpdateLoading: false,
      dateMenu: false
    }
  },

  computed: {
    ...mapGetters({
      viewInfo: 'closingEntries/getClosingEntry'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateViewInfo: 'closingEntries/updateClosingEntry'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true
          let formData = new FormData(event.target)

          let payload = { id: this.viewInfo.closing_id, formData }
          this.updateViewInfo(payload)
            .then(() => {
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
